import {connect} from 'react-redux';
import {
    getEquivalencies
} from '../../redux/modules/reducer';
import Equivalencies from './Equivalencies';

const mapStateToProps = (state) => ({
    equivalencies: getEquivalencies(state),
});

export default connect(
    mapStateToProps,
)(Equivalencies);


/** WEBPACK FOOTER **
 ** ./src/components/Equivalencies/index.js
 **/